export default __webpack_public_path__ + "static/media/flag-pakistan.642709d7.svg";